import React from "react";
import { FiUsers, FiHelpCircle, FiLogOut, FiCalendar, FiDollarSign, FiUserCheck, FiMail, FiBell } from "react-icons/fi";
import logo from "../assets/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AiFillDashboard } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/reducers/authSlice";
import { FaUser } from "react-icons/fa";

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedMenu = location.pathname.split("/")[1];
  const { userDetails } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div className="min-h-screen h-screen overflow-auto rounded-r flex flex-col bg-primary text-white w-16 sm:w-20 lg:w-64 transition-all duration-300 ease-in-out">
      <div className="flex items-center justify-start p-2 lg:p-4">
        <img src={logo} alt="Logo" className="hidden lg:block" width={100} />
        <span className="text-lg font-bold py-2 hidden lg:block">
          Revenue Pro Planner
        </span>
      </div>
      <nav className="flex-grow mt-6">
        <ul className="space-y-2 px-2 lg:px-4">
          <li>
            <Link
              to={"/admin-dashboard"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "admin-dashboard" ? "bg-gray-800" : ""
              }`}
            >
              <AiFillDashboard className="text-xl" />
              <span className="ml-3 hidden lg:block">Dashboard</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/user-management"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "user-management" ? "bg-gray-800" : ""
              }`}
            >
              <FiUsers className="text-xl" />
              <span className="ml-3 hidden lg:block">Users</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/year-management"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "year-management" ? "bg-gray-800" : ""
              }`}
            >
              <FiCalendar className="text-xl" />
              <span className="ml-3 hidden lg:block">Year Management</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/pricing-management"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "pricing-management" ? "bg-gray-800" : ""
              }`}
            >
              <FiDollarSign className="text-xl" />
              <span className="ml-3 hidden lg:block">Pricing</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/trial-requests"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "trial-requests" ? "bg-gray-800" : ""
              }`}
            >
              <FiUserCheck className="text-xl" />
              <span className="ml-3 hidden lg:block">Trial Requests</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/email-center"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "email-center" ? "bg-gray-800" : ""
              }`}
            >
              <FiMail className="text-xl" />
              <span className="ml-3 hidden lg:block">Email Center</span>
            </Link>
          </li>
          <li>
            <Link
              to={"/announcements"}
              className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
                selectedMenu === "announcements" ? "bg-gray-800" : ""
              }`}
            >
              <FiBell className="text-xl" />
              <span className="ml-3 hidden lg:block">Announcements</span>
            </Link>
          </li>
        </ul>
      </nav>
      <div className="px-2 lg:px-4">
        <div className="border-t border-gray-700 py-4">
          <div className="flex items-center ml-3 space-x-2 lg:space-x-4">
            <div className="">
              <FaUser className="text-xl" />
            </div>
            <div className="hidden lg:block">
              <p className="text-sm">{userDetails?.name}</p>
              <p className="text-xs text-gray-400 w-48 truncate cursor-pointer">
                {userDetails?.email ?? "-"}
              </p>
            </div>
          </div>
        </div>
        <div className="space-y-2 mb-4">
          <Link
            to={"/admin-settings"}
            className={`flex items-center px-2 lg:px-4 py-2 hover:bg-gray-800 rounded-md ${
              selectedMenu === "admin-settings" ? "bg-gray-800" : ""
            }`}
          >
            <FiHelpCircle className="text-xl" />
            <span className="ml-3 hidden lg:block">Settings</span>
          </Link>
          <button
            onClick={handleLogout}
            className="flex items-center px-2 lg:px-4 py-2 hover:bg-white rounded-md text-red-600 w-full bg-red-100 font-bold"
          >
            <FiLogOut className="text-xl" />
            <span className="ml-3 hidden lg:block">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
